<div #mapContainer class="carte-map" aria-label="Carte des installations">
  @if (!installationsAvecCoordonnees().length) {
    <div class="carte-empty-state">Aucune coordonnée disponible</div>
  }
  <button class="carte-expand-btn" aria-label="Agrandir la carte" (click)="ouvrirModal()">
    <span class="material-symbols-outlined">fullscreen</span>
  </button>
</div>

@if (modalVisible) {
  <div class="carte-modal-backdrop" (click)="fermerModalSurBackdrop($event)">
    <div class="carte-modal" role="dialog" aria-modal="true" aria-label="Carte des installations">
      <div class="carte-modal-header">
        <h2>Carte des installations</h2>
        <div class="carte-modal-legend legend-pills">
          @for (n of legendeNiveaux; track n.niveau) {
            <span class="legend-pill"><i class="dot" [style.background]="n.couleur"></i>{{ n.label }}</span>
          }
        </div>
        <button class="carte-modal-close" (click)="fermerModal()" aria-label="Fermer">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
      <div class="carte-modal-body">
        <div #mapContainerModal class="carte-modal-map" aria-label="Carte des installations en plein écran"></div>
      </div>
    </div>
  </div>
}
